import { z } from "zod"
import {
  type Column,
  columnSchema,
  DEFAULT_COLUMNS,
  withFixed,
} from "./columns"
import { BASES } from "./forecasts"

export const FORECASTS = { limit: 200 }

export const TABS = ["all", "active", "archived"] as const

const tabSchema = z.enum(TABS)

export type Tab = z.infer<typeof tabSchema>

export const GROUPINGS = ["projection", "creator"] as const

const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const GROUPING_LABELS: Record<Grouping, string> = {
  projection: "Projection",
  creator: "Created by",
}

const directionSchema = z.enum(["asc", "desc"])

export type Direction = z.infer<typeof directionSchema>

export const forecastsSearchSchema = z.object({
  tab: tabSchema.optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  basis: z.array(z.enum(BASES)).optional().catch(undefined),
  creator: z.array(z.string()).optional().catch(undefined),
  group: groupingSchema.optional().catch(undefined),
  columns: z.array(columnSchema).optional().catch(undefined),
  sort: columnSchema.optional().catch(undefined),
  direction: directionSchema.optional().catch(undefined),
})

export type ForecastsSearch = z.infer<typeof forecastsSearchSchema>

export type ForecastsDisplay = {
  group: Grouping | undefined
  columns: Column[]
  sort: Column
  direction: Direction
}

export function tabLabel(tab: Tab): string {
  switch (tab) {
    case "active":
      return "Active"
    case "archived":
      return "Archived"
    case "all":
      return "All"
  }
}

export function displayOf(search: ForecastsSearch): ForecastsDisplay {
  return {
    group: search.group,
    columns: search.columns ? withFixed(search.columns) : DEFAULT_COLUMNS,
    sort: search.sort ?? "number",
    direction: search.direction ?? "desc",
  }
}
